import PraisoServices from "./PraisoServices";
import { getContentToken, getToken, setContentSession } from "./LocalStorageService";

export const ContentDetailsAPI = async (contentParams:any, params:any) => {
    let ApiUrl = `campaign/content-details/${contentParams.contentId}`;

    let token;
    let header = {};
    if (contentParams.mobileToken) {
        token = contentParams.mobileToken;
    } else {
        token = getToken();
    }
    if (token) {
        header[`Authorization`] = `Bearer ${token}`;
    }
    let payLoad = {};
    if (contentParams.emailToken) {
        ApiUrl = `auth/email-session`;
        payLoad[`emailToken`] = contentParams.emailToken
        payLoad['contentId'] = contentParams.contentId
    }
    if (contentParams.isPreview) {
        payLoad[`isPreview`] = contentParams.isPreview
    }
    if (params.impersonationid) {
        payLoad['impersonationId'] = params.impersonationid;
    }
    try {
        const response = await PraisoServices(
            ApiUrl,
            "post",
            {
                ...payLoad
            },
            {},
            {
                ...header
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
              status: {
                code: 1,
                message: err?.message,
              },
              content: null,
            };
          }
        } catch (error_1) {
          const err = error_1 as Error;
          return {
            status: {
              code: 1,
              message: err.message,
            },
            content: null,
          };
        }
};

export const UpdateContentApi = async (contentParams, params) => {
    window.localStorage.removeItem("API");
    const ApiUrl = `campaign/content-update/${contentParams.contentId}`;
    let token = getToken();
    let contentToken = getContentToken();
    let header = {};
    if (contentToken) {
        token = contentToken
    }
    if (contentParams.mobileToken) {
        token = contentParams.mobileToken;
    }

    if (token) {
        header[`Authorization`] = `Bearer ${token}`;
    }

    let payLoad = {};
    if (contentParams) {
        if (contentParams.contentId) {
            payLoad[`contentId`] = contentParams.contentId;
        }
        if (contentParams.contentTypeId) {
            payLoad[`contentTypeId`] = contentParams.contentTypeId;
        }
        if (contentParams.contentCompletedPercentage) {
            payLoad[`contentCompletedPercentage`] = contentParams.contentCompletedPercentage;
        }
        if (contentParams.quizQuestionId) {
            payLoad[`quizQuestionId`] = contentParams.quizQuestionId;
        }
        if (contentParams.selectedAnswerId) {
            payLoad[`selectedAnswerId`] = contentParams.selectedAnswerId;
        }
        if (contentParams.isFinish) {
            payLoad[`isFinish`] = contentParams.isFinish;
        }
        if (params.impersonationid) {
            payLoad['impersonationId'] = params.impersonationid;
        }
    }
    try {
        const response = await PraisoServices(
            ApiUrl,
            "post",
            {
                ...payLoad
            },
            {},
            {
                ...header
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
              status: {
                code: 1,
                message: err?.message,
              },
              content: null,
            };
          }
        } catch (error_1) {
          const err = error_1 as Error;
          return {
            status: {
              code: 1,
              message: err.message,
            },
            content: null,
          };
        }
};

export const GetContentFromOldUrlApi = async (contentParams, params) => {
    const ApiUrl = `auth/getContent`;
    if (params.impersonationid) {
        contentParams.impersonationId = params.impersonationid;
    }
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {
                ...contentParams
            },
            {}
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
              status: {
                code: 1,
                message: err?.message,
              },
              content: null,
            };
          }
        } catch (error_1) {
          const err = error_1 as Error;
          return {
            status: {
              code: 1,
              message: err.message,
            },
            content: null,
          };
        }
};

export const getContentDetails = async (contentParams, params) => {
    const data = await ContentDetailsAPI(contentParams, params);
    if (data && data.content && data.content.session) {
        setContentSession(data.content.session)
    }
    return data;
    // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
    //     return data;
    // } else {
    //     return data;
    // }
};

export const updateContent = async (contentParams, params) => {
    const data = await UpdateContentApi(contentParams, params);
    return data;
    // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
    //     return data;
    // } else {
    //     return data;
    // }
};


export const getContentFromOldUrl = async (contentParams, params) => {
    const data = await GetContentFromOldUrlApi(contentParams, params);
    return data;
    // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
    //     return data;
    // } else {
    //     return data;
    // }
};
